
export const ParamMethod = {
    regex: /\${[\w\-]+\}/g,
    contains: (url: string): boolean => {
        return (ParamMethod.regex.test(url));
    },
    match: (url: string): { from: string, control: string }[] => {
        return (url.match(ParamMethod.regex) || []).map(m => ({ from: m, control: m.substring(m.indexOf('${') + 2, m.indexOf('}')) }));
    }
}

export const VariableMethod = {
  regex: /\#{[\w\-]+\}/g,
  contains: (url: string): boolean => {
    return (VariableMethod.regex.test(url));
  },
  match: (url: string, params: { [k: string]: string | number }): { from: string, value: string | number }[] => {
    return (url.match(VariableMethod.regex) || []).map(m =>
      ({ from: m, value: params[m.substring(m.indexOf('#{') + 2, m.indexOf('}'))] }));
  }
}


export const openLink = (link: string, newPage: boolean) => {
    // const a = document.createElement('a');
    // a.href = link;
    // if (newPage) {
    //     a.target = '_blank';
    // }
    // document.appendChild(a);
    // a.click();
    // document.removeChild(a);
}
